export default [{ Value: 1, Text: 'Draft' },
{ Value: 2, Text: 'Published' },
{ Value: 3, Text: 'Archived' }]